export default "__VITE_ASSET__5ef3cb45__"